import clsx from "clsx";
import { FC, ReactNode } from "react";

type Props = {
  num?: number | null;
  className?: string;
  defaultOutput?: ReactNode;
  shouldAbbreviate?: boolean;
};

const Number: FC<Props> = ({
  num,
  className,
  defaultOutput = "",
  shouldAbbreviate = false
}) => (
  <span className={clsx(className)}>
    {num != null ? num.format({ abbr: shouldAbbreviate }) : defaultOutput}
  </span>
);

export default Number;
